'use client';
export default function Loading() {
  return <div>...</div>;
}
